var z = (a) => {
  throw TypeError(a);
};
var _ = (a, i, e) => i.has(a) || z("Cannot " + e);
var b = (a, i, e) => (_(a, i, "read from private field"), e ? e.call(a) : i.get(a)), f = (a, i, e) => i.has(a) ? z("Cannot add the same private member more than once") : i instanceof WeakSet ? i.add(a) : i.set(a, e), h = (a, i, e, t) => (_(a, i, "write to private field"), t ? t.call(a, e) : i.set(a, e), e);
import { i as L, B, e as O, b as D, T as F, x as u, n as S, a as d, r as k } from "../separate-component-helper-chunks/abstract-base-xBS_db8B.js";
import { e as M } from "../separate-component-helper-chunks/query-Dk6NwgU8.js";
import { o as x } from "../separate-component-helper-chunks/query-assigned-elements-6bru_WLT.js";
import { e as p } from "../separate-component-helper-chunks/class-map-DwFRvGYD.js";
import { o as C } from "../separate-component-helper-chunks/unsafe-svg-D86uUP5h.js";
import { B as A } from "../separate-component-helper-chunks/breakpoints-BOBcTZS0.js";
import { b as P, a as N } from "../separate-component-helper-chunks/baseline-plus-bAs8tj2E.js";
import { c as V } from "../separate-component-helper-chunks/cache-Cmvf5ilk.js";
import { p as H } from "../separate-component-helper-chunks/lifecycle-decorators-CUsT9aHq.js";
import { s as g } from "../separate-component-helper-chunks/showIfUsed-BOUMDEyq.js";
import { g as T } from "../separate-component-helper-chunks/uid-HAKIZOcY.js";
var I = /* @__PURE__ */ ((a) => (a.PRIMARY = "primary", a.SECONDARY = "secondary", a))(I || {});
const $ = {
  beaconTagName: "beacon-control"
}, R = L`[beacon-tag-name=beacon-control]:has(input[type=hidden]){display:none}[beacon-tag-name=beacon-control] input:is(:-webkit-autofill,:autofill){border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control]:has(input:checked)::part(field){--hover-outline-color: var(--beacon-system-color-background-primary);border:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input:checked)[invalid]::part(field){border-color:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:has(input:checked)[disabled]:not([invalid])::part(field){border-color:transparent}[beacon-tag-name=beacon-control]:has(input:checked) label{font-weight:var(--beacon-system-font-weight-bold)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has(input[type=number]) input{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);gap:var(--beacon-reference-space-4);inline-size:36px;min-block-size:var(--beacon-reference-space-10);padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has(input[type=number]) input::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has(input[type=number]) input.invalid{outline:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has(input[type=number]) input:hover{outline:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has(input[type=number]) input:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc( var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) );outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal));position:relative;z-index:1}[beacon-tag-name=beacon-control] .option-label{font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default))}[beacon-tag-name=beacon-control]:has(input)[toggle-switch] input[type=checkbox].beacon-control__field{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-image:none;block-size:100%;border:0;cursor:pointer;inline-size:100%;inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field){block-size:var(--beacon-reference-space-8);border-radius:var(--beacon-system-radius-corner-round);inline-size:var(--beacon-reference-space-12);position:relative}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field):before{background-color:var(--beacon-system-color-background-2);block-size:var(--beacon-reference-space-5);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:50%;content:"";inline-size:var(--beacon-reference-space-5);inset-block-start:50%;inset-inline-start:var(--beacon-reference-space-2);pointer-events:none;position:absolute;transform:translateY(-50%)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field){background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):hover{--hover-outline-color: transparent;background-color:var(--beacon-system-color-background-primary-hover)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):before{block-size:var(--beacon-reference-space-6);border:0;inline-size:var(--beacon-reference-space-6);inset-inline-start:calc(100% - var(--beacon-reference-space-6) - var(--beacon-reference-space-2))}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled] label{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled]::part(field):before{border-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[aria-disabled=true]::part(field),[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[disabled]::part(field){background-color:var(--beacon-component-form-color-foreground-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control]:has(textarea){--control-overflow: hidden}[beacon-tag-name=beacon-control]:has(textarea):not([non-resizable]){--control-resize: both}[beacon-tag-name=beacon-control]:has(textarea) textarea{block-size:100%;inline-size:100%;resize:none}[beacon-tag-name=beacon-control]:has([slot=prefix]){--control-padding-inline-start: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has([slot=suffix]),[beacon-tag-name=beacon-control]:has([type=password]):not([disable-password-toggle]){--control-padding-inline-end: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has(input[aria-disabled=true]) label{pointer-events:none}[beacon-tag-name=beacon-control] label{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default))}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]){background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-invalid=true],:invalid){border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field{background-color:transparent;border:0;color:var(--beacon-system-color-text-standard);inline-size:100%;outline:0}[beacon-tag-name=beacon-control] .beacon-control__field:not([type=checkbox],[type=radio],select){padding-block:var(--beacon-reference-space-3);padding-inline-end:var(--control-padding-inline-end, var(--beacon-reference-space-4));padding-inline-start:var(--control-padding-inline-start, var(--beacon-reference-space-4))}[beacon-tag-name=beacon-control] .beacon-control__field[aria-disabled=true],[beacon-tag-name=beacon-control] .beacon-control__field:disabled{caret-color:transparent;color:var(--beacon-system-color-text-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8);cursor:pointer;inline-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=date]{block-size:var(--beacon-reference-space-10)}}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]{border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{accent-color:var(--beacon-system-color-background-primary);-webkit-appearance:revert;-moz-appearance:revert;appearance:revert}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){accent-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){accent-color:var(--beacon-system-color-icon-error)}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);background-image:url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");background-position:center;background-repeat:no-repeat;border-radius:unset}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]{border-radius:50%;padding:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked{background-clip:content-box;background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}[beacon-tag-name=beacon-control] .beacon-control__field:is(select){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;padding-block:var(--beacon-reference-space-3);padding-inline-end:var(--control-padding-inline-end, var(--beacon-reference-space-9));padding-inline-start:var(--control-padding-inline-start, var(--beacon-reference-space-4));background-image:url('data:image/svg+xml,<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Dropdown"><path id="Icon" d="M8 12L3 4.5L13 4.5L8 12Z" fill="%230063AD"/></g></svg>');background-position:calc(100% - var(--beacon-reference-space-4)) 50%;background-repeat:no-repeat}[beacon-tag-name=beacon-control] .beacon-control__field:is(select) option{color:var(--beacon-reference-palette-grayscale-dark-gray-3)}[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[disabled],[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[aria-disabled=true]{background-image:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 11.5L3 4L13 4L8 11.5Z" fill="%23D3D7DA"/></svg>');opacity:.7}[beacon-tag-name=beacon-control][data-mode=dark] :is(input,textarea,select){color-scheme:dark}[beacon-tag-name=beacon-control][data-mode=dark] select{background-image:url('data:image/svg+xml,<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Dropdown"><path id="Icon" d="M8 12L3 4.5L13 4.5L8 12Z" fill="%2390C6CA"/></g></svg>')}`, j = L`:host{display:flex;flex-direction:column}.group{align-items:var(--control-alignment, start);display:flex;flex-direction:var(--beacon-custom-control-flex-direction, var(--control-direction, column));gap:var(--beacon-reference-space-3);inline-size:var(--control-group-inline-size, 100%);justify-content:start}.group.inline{--control-direction: row-reverse}.group.inline .field{flex-shrink:0}.group:has(.radio,.checkbox){--control-alignment: center;gap:var(--beacon-reference-space-4)}.group:has(.date){--control-group-inline-size: fit-content}.field{align-items:center;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);display:flex;font:var(--beacon-system-font-weight-light) var(--beacon-component-form-font-size-sans-serif-standard);overflow:var(--control-overflow, initial);resize:var(--control-resize, none)}.field:not(.radio,.checkbox){inline-size:var(--beacon-custom-control-inline-size, var(--control-inline-size, 100%))}.field.disabled{background-color:var(--beacon-component-form-color-background-inactive);border-color:transparent;pointer-events:none}.field.readOnly{background-color:var(--beacon-system-color-background-0);border-color:var(--beacon-system-color-border-0)}.field.invalid{border-color:var(--beacon-system-color-border-error);outline:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-error)}.field.invalid:where(.number.stepper){outline:none}.field:hover:not(.invalid,:focus-within){outline:var(--beacon-system-width-border-mini) solid var(--hover-outline-color, var(--beacon-component-form-color-border-standard))}.field:focus-within{border-color:var(--beacon-system-color-border-primary)}.field:focus-within:not(:has(slot[name=prefix]:focus-within)){--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc( var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) );outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal));position:relative;z-index:1}.field:focus-within.invalid{border-color:var(--beacon-system-color-border-error)}.field:focus-within.disabled{border-color:var(--beacon-system-color-border-primary)}.field:focus-within.readOnly{border-color:var(--beacon-system-color-border-0)}.field:where(.date){--control-inline-size: 100%}.field:where(.select){--control-inline-size: 100%}@media (width >= 640px){.field:where(.select){--control-inline-size: fit-content}}.field:where(.radio){border-radius:50%}.field.number.stepper{background:transparent;border:0;gap:var(--beacon-reference-space-3)}.field.number.stepper:is(:hover,:focus-within){outline:none}.prefix,.suffix{flex-shrink:0}.prefix{margin-inline-start:var(--beacon-reference-space-4)}.suffix{margin-inline-end:var(--beacon-reference-space-4)}.suffix.password:not(.password-visible) .hide-password{display:none}.suffix.password.password-visible .show-password{display:none}.suffix.password ::part(standard-button){margin:0;padding:0;position:relative}.suffix.password ::part(standard-button):before{block-size:var(--beacon-reference-space-10);content:"";inline-size:var(--beacon-reference-space-10);inset-block-start:calc(-1 * var(--beacon-reference-space-4));position:absolute}.toggle-switch-label:not(.checkbox-checked) .switch-on-label{display:none}.toggle-switch-label.checkbox-checked .switch-off-label{display:none}.stepper{margin-inline-end:0;margin-inline-start:0}.hint{font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default))}.error:not(.visible){display:none}.hint,.error{margin-block-start:var(--beacon-reference-space-2)}.beacon-stepper-button{--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9);align-items:flex-start;display:flex;padding:var(--beacon-reference-space-2)}`;
var W = Object.defineProperty, Q = Object.getOwnPropertyDescriptor, r = (a, i, e, t) => {
  for (var n = t > 1 ? void 0 : t ? Q(i, e) : i, s = a.length - 1, c; s >= 0; s--)
    (c = a[s]) && (n = (t ? c(i, e, n) : c(n)) || n);
  return t && n && W(i, e, n), n;
}, m, v, y, w, E, l;
const o = (l = class extends B {
  constructor() {
    super();
    f(this, m);
    f(this, v);
    f(this, y);
    f(this, w);
    f(this, E);
    this.beaconTagName = $.beaconTagName, this.resetSpacing = !0, this.focusOverride = !0, this.inline = !1, this.disablePasswordToggle = !1, this.disableToggleSwitchLabel = !1, this.nonResizable = !1, this.toggleSwitch = !1, this.disabled = !1, this.invalid = !1, this.readOnly = !1, this.stepperVariant = I.PRIMARY, this.passwordVisible = !1, this.isCheckboxChecked = !1, h(this, m, void 0), this.preventDisabledEvents = this.preventDisabledEvents.bind(this), this.handleFieldElementInvalid = this.handleFieldElementInvalid.bind(this), this.handleFieldElementOnChange = this.handleFieldElementOnChange.bind(this);
  }
  static get styles() {
    return [super.styles, j];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, R];
  }
  get labelElement() {
    return b(this, v);
  }
  set labelElement(e) {
    h(this, v, e);
  }
  get fieldElement() {
    return b(this, y);
  }
  set fieldElement(e) {
    h(this, y, e), this.fieldElement && (l.applyClassNameToField(this.fieldElement), O(this, D.CONTROL_SET), this.setInputType(), this.setupSlottedFieldEventListeners(), this.setDisabledState(), this.setInvalidState(), this.setReadOnlyState(), this.setSwitchRole(), this.applyFieldElementObserver(), this.initializeIsCheckboxChecked());
  }
  get hintElement() {
    return b(this, w);
  }
  set hintElement(e) {
    h(this, w, e), this.hintElement && !this.hintElement.id && (this.hintElement.id = T()), this.setFieldAriaDescribedBy();
  }
  get errorElement() {
    return b(this, E);
  }
  set errorElement(e) {
    h(this, E, e), this.errorElement && !this.errorElement.id && (this.errorElement.id = T()), this.associateErrorWithField();
  }
  get currentInputType() {
    if (this.fieldElement)
      return this.fieldElement.type;
  }
  get isStepper() {
    return this.inputType === "number" && this.stepperVariant !== "none";
  }
  get controlGroup() {
    return V(this, "_controlGroup", () => this.closest(this.getScopedTagName("beacon-control-group")));
  }
  getAriaDescribedByIds() {
    var t, n;
    const e = [this.dataset.hintId || ((t = this.hintElement) == null ? void 0 : t.id)];
    return this.invalid && e.push(this.dataset.errorId || ((n = this.errorElement) == null ? void 0 : n.id)), e;
  }
  setFieldAriaDescribedBy(e = this.getAriaDescribedByIds()) {
    if (!this.fieldElement) return;
    const t = e.filter((s) => s);
    if (t.length === 0) {
      this.fieldElement.removeAttribute("aria-describedby");
      return;
    }
    const n = t.join(" ");
    this.fieldElement.setAttribute("aria-describedby", n);
  }
  associateErrorWithField(e = ((t) => (t = this.errorElement) == null ? void 0 : t.id)()) {
    if (!this.fieldElement) return;
    const n = this.dataset.errorId || e;
    this.invalid ? n && this.fieldElement.setAttribute("aria-errormessage", n) : this.fieldElement.removeAttribute("aria-errormessage"), this.setFieldAriaDescribedBy();
  }
  handleLabelSlotchange() {
    this.labelElement = l.setElementFromQuery(this.labelElements);
  }
  /**
   * Calls preventDefault on all non-keyboard interactive events triggered
   * when this component is disabled.
   *
   * Notably, this does not prevent ArrowKeys or Spacebar from date inputs.
   * @param event
   */
  preventDisabledEvents(e) {
    if (!this.disabled) return;
    const t = ["Shift", "Tab"];
    let n;
    e && e instanceof KeyboardEvent && (n = e.key), n && t.includes(n) || e.preventDefault();
  }
  setupSlottedFieldEventListeners() {
    var e, t, n, s;
    (e = this.fieldElement) == null || e.addEventListener("keydown", this.preventDisabledEvents), (t = this.fieldElement) == null || t.addEventListener("click", this.preventDisabledEvents), (n = this.fieldElement) == null || n.addEventListener("invalid", this.handleFieldElementInvalid), (s = this.fieldElement) == null || s.addEventListener("change", this.handleFieldElementOnChange);
  }
  handleFieldSlotchange() {
    this.fieldElement = l.setElementFromQuery(this.fieldElements), this.isStepper && this.fieldElement instanceof HTMLInputElement && (this.updateStepperSlottedInputValue(), this.fieldElement.value || (this.fieldElement.value = this.fieldElement.min || "1"), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState());
  }
  handleHintSlotchange() {
    this.hintElement = l.setElementFromQuery(this.hintElements);
  }
  handleErrorSlotchange() {
    this.errorElement = l.setElementFromQuery(this.errorElements);
  }
  handleFieldElementInvalid(e) {
    var t;
    (t = this.fieldElement) == null || t.setAttribute("aria-invalid", "true");
  }
  handleFieldElementOnChange(e) {
    const t = e == null ? void 0 : e.target;
    t && (t == null ? void 0 : t.type) === "checkbox" && (this.isCheckboxChecked = t == null ? void 0 : t.checked);
  }
  applyFieldElementObserver() {
    this.fieldElement && !b(this, m) && (h(this, m, new MutationObserver((e) => {
      e.find((c) => c.attributeName === "aria-disabled" || c.attributeName === "disabled") && this.setDisabledState(), e.find((c) => c.attributeName === "aria-invalid") && this.setInvalidState(), e.find((c) => c.attributeName === "readonly") && this.setReadOnlyState();
    })), b(this, m).observe(this.fieldElement, {
      attributes: !0
    }));
  }
  updateStepperSlottedInputValue() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.addEventListener("input", (t) => {
      const n = t.target;
      n && (this.fieldElement.value = n.value, this.validatedStepper());
    });
  }
  validatedStepper() {
    var e, t;
    if (this.isStepper && this.fieldElement instanceof HTMLInputElement) {
      const n = this.fieldElement.value, s = new CustomEvent("change", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          value: n
        }
      });
      this.fieldElement.dispatchEvent(s), n.length > 1 ? this.fieldElement.style.inlineSize = n.length + 3 + "ch" : this.fieldElement.style.inlineSize = "36px", (e = this.fieldElement.parentElement) != null && e.clientWidth && (((t = this.fieldElement.parentElement) == null ? void 0 : t.clientWidth) <= A.DEFAULT ? this.fieldElement.style.inlineSize = n.length + 3.5 + "ch" : F), this.fieldElement.setAttribute("aria-invalid", String(this.setStepperValidity())), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState();
    }
  }
  setStepperValidity() {
    if (this.fieldElement instanceof HTMLInputElement) {
      const { min: e, max: t, value: n } = this.fieldElement;
      return !!(e && Number(n) < Number(e) || t && Number(n) > Number(t));
    }
    return !1;
  }
  setMinusButtonState() {
    if (this.fieldElement instanceof HTMLInputElement) {
      if (this.fieldElement.min)
        return Number(this.fieldElement.min) >= Number(this.fieldElement.value);
      if (this.fieldElement.value === "0")
        return !0;
    }
    return !1;
  }
  setPlusButtonState() {
    return this.fieldElement instanceof HTMLInputElement && this.fieldElement.max ? Number(this.fieldElement.max) <= Number(this.fieldElement.value) : !1;
  }
  incrementStepper(e) {
    var t;
    if (this.fieldElement) {
      ((t = this.fieldElement) == null ? void 0 : t.value) === "" && (this.fieldElement.value = "0");
      const n = String(this.fieldElement.value), s = Number(n != null ? n : 0) + 1;
      this.fieldElement.value = String(s), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  decrementStepper(e) {
    var t;
    if (this.fieldElement) {
      ((t = this.fieldElement) == null ? void 0 : t.value) === "" && (this.fieldElement.value = "0");
      const n = String(this.fieldElement.value), s = Number(n != null ? n : 0) - 1;
      this.fieldElement.value = String(s), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  setInputType() {
    this.fieldElement instanceof HTMLInputElement ? this.inputType = this.fieldElement.type : this.inputType = this.fieldElement.localName;
  }
  setDisabledState() {
    if (this.fieldElement) {
      if (this.fieldElement.disabled) {
        this.disabled = this.fieldElement.disabled;
        return;
      }
      const e = this.fieldElement.getAttribute("aria-disabled");
      e === null ? this.disabled = this.fieldElement.disabled : this.disabled = e === "true";
    }
  }
  setInvalidState() {
    if (this.fieldElement) {
      const e = this.fieldElement.getAttribute("aria-invalid");
      this.invalid = e === "true", this.associateErrorWithField(), this.controlGroup && (this.controlGroup.invalid = this.invalid);
    }
  }
  setReadOnlyState() {
    (this.fieldElement instanceof HTMLInputElement || this.fieldElement instanceof HTMLTextAreaElement) && (this.readOnly = this.fieldElement.readOnly);
  }
  // Initialize `isCheckboxChecked` to match the actual checked state
  initializeIsCheckboxChecked() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.isCheckboxChecked = this.fieldElement.checked);
  }
  setSwitchRole() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.toggleSwitch ? this.fieldElement.setAttribute("role", "switch") : this.fieldElement.removeAttribute("role"));
  }
  static setElementFromQuery(e) {
    return e[0];
  }
  static applyClassNameToField(e) {
    e && e.classList.add("beacon-control__field");
  }
  renderLabelSlot() {
    if (this.toggleSwitch) {
      const e = {
        "checkbox-checked": this.isCheckboxChecked,
        "toggle-switch-label": !0,
        label: !0
      };
      return u`
        <span class=${p(e)}>
          <slot name="label">
            <span class="switch-on-label">
              <slot name="switch-on-label"></slot>
            </span>
            <span class="switch-off-label">
              <slot name="switch-off-label"></slot>
            </span>
          </slot>
        </span>
      `;
    }
    return u`
      <div class="label" part="label">
        <slot name="label" @slotchange=${this.handleLabelSlotchange} ${g({ useParent: !0 })}></slot>
      </div>
    `;
  }
  renderPrefix() {
    return this.isStepper ? S`
      <div class="${p({
      stepper: !0,
      prefix: !0
    })}">
        <slot name="prefix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}" 
          id="decrement"
          @beacon-event-click=${this.decrementStepper}
          ?disabled=${this.disabled || this.disabledMinusValue}>
          ${C(P)} decrement button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : u`
        <div class="prefix">
          <slot name="prefix" ${g({ useParent: !0 })}></slot>
        </div>
      `;
  }
  renderFieldSlot() {
    return u`<slot @slotchange=${this.handleFieldSlotchange}></slot>`;
  }
  renderSuffix() {
    const e = this.disablePasswordToggle || this.disabled || this.readOnly;
    if (this.inputType === "password" && !e) {
      const t = {
        password: !0,
        "password-visible": this.passwordVisible,
        suffix: !0
      };
      return S`
        <div class="${p(t)}">
          <slot name="suffix">
            <${this.getScopedTag("beacon-button")} class="password-toggle" variant="tertiary" scale="mini" @beacon-event-click=${this.handleTogglePassword}>
              <span class="show-password">
                <slot name="show-password">Show</slot>
              </span>
              <span class="hide-password">
                <slot name="hide-password">Hide</slot>
              </span>
            </${this.getScopedTag("beacon-button")}>
          </slot>
        </div>
      `;
    }
    return this.isStepper ? S`
      <div class="${p({
      stepper: !0,
      suffix: !0
    })}">
        <slot name="suffix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}"
          id="increment" 
          @beacon-event-click=${this.incrementStepper}
          ?disabled=${this.disabled || this.disabledPlusValue}>
          ${C(N)} increment button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : u`
        <div class="suffix">
          <slot name="suffix" ${g({ useParent: !0 })}></slot>
        </div>
      `;
  }
  handleTogglePassword(e) {
    var t, n;
    this.passwordVisible = !this.passwordVisible, this.passwordVisible ? (t = this.fieldElement) == null || t.setAttribute("type", "text") : (n = this.fieldElement) == null || n.setAttribute("type", "password");
  }
  // helps with syncing the browser UI with our modes
  setColorSchemeCSS() {
    const e = this.closest('[class*="beacon-on"]');
    if (e) {
      const t = Array.from(e.classList).find((n) => n.startsWith("beacon-on"));
      t != null && t.includes("dark") && (this.dataset.mode = "dark");
    }
  }
  render() {
    const e = {
      group: !0,
      inline: this.inline
    }, t = {
      disabled: this.disabled,
      field: !0,
      readOnly: this.readOnly,
      invalid: this.invalid,
      stepper: this.isStepper
    };
    this.inputType && (t[this.inputType] = !0);
    const n = {
      "beacon-theme-modern-outlook": !0,
      error: !0,
      visible: this.invalid
    };
    return S`
      <div class="${p(e)}">
        ${this.renderLabelSlot()}
        <!-- prettier-ignore -->
        <div class="${p(t)}" part="field">
          ${this.renderPrefix()}
          ${this.renderFieldSlot()}
          ${this.renderSuffix()}
        </div>
      </div>
      <div id="hint" class="hint">
        <slot name="hint" @slotchange=${this.handleHintSlotchange} ${g({ useParent: !0 })}></slot>
      </div>
      <${this.getScopedTag("beacon-error")} id="error" class="${p(n)}" role="alert">
        <slot name="error" @slotchange=${this.handleErrorSlotchange} ${g({ useParent: !0 })}></slot>
      </${this.getScopedTag("beacon-error")}>
    `;
  }
}, m = new WeakMap(), v = new WeakMap(), y = new WeakMap(), w = new WeakMap(), E = new WeakMap(), l.tagName = $.beaconTagName, l.nestedComponents = ["beacon-error", "beacon-button", "beacon-icon-button"], l);
r([
  d({ type: Boolean })
], o.prototype, "inline", 2);
r([
  d({ type: Boolean, attribute: "disable-password-toggle" })
], o.prototype, "disablePasswordToggle", 2);
r([
  d({ type: Boolean, attribute: "disable-toggle-switch-label" })
], o.prototype, "disableToggleSwitchLabel", 2);
r([
  d({ type: Boolean, reflect: !0, attribute: "non-resizable" })
], o.prototype, "nonResizable", 2);
r([
  d({ type: Boolean, reflect: !0, attribute: "toggle-switch" })
], o.prototype, "toggleSwitch", 2);
r([
  d({ type: Boolean, reflect: !0 })
], o.prototype, "disabled", 2);
r([
  d({ type: Boolean, reflect: !0 })
], o.prototype, "invalid", 2);
r([
  d({ type: Boolean, reflect: !0 })
], o.prototype, "readOnly", 2);
r([
  d({ type: String, reflect: !0, attribute: "stepper-variant" })
], o.prototype, "stepperVariant", 2);
r([
  k()
], o.prototype, "disabledMinusValue", 2);
r([
  k()
], o.prototype, "disabledPlusValue", 2);
r([
  k()
], o.prototype, "inputType", 2);
r([
  k()
], o.prototype, "passwordVisible", 2);
r([
  k()
], o.prototype, "isCheckboxChecked", 2);
r([
  M("[toggle-password]")
], o.prototype, "passwordToggleButton", 2);
r([
  x({ flatten: !0, slot: "label" })
], o.prototype, "labelElements", 2);
r([
  x({ flatten: !0 })
], o.prototype, "fieldElements", 2);
r([
  x({ flatten: !0, slot: "hint" })
], o.prototype, "hintElements", 2);
r([
  x({ flatten: !0, slot: "error" })
], o.prototype, "errorElements", 2);
r([
  x({ flatten: !0, slot: "suffix", selector: "[toggle-password]" })
], o.prototype, "togglePasswordButtons", 2);
r([
  H
], o.prototype, "setColorSchemeCSS", 1);
let oe = o;
export {
  oe as BeaconControl
};
